/* eslint react/no-array-index-key: 0 */
import React, { useEffect, useState } from 'react'
import { DragDropContext, Droppable } from 'react-beautiful-dnd'
import ITable, { IHeaderItem, IItem } from '../../interfaces/table'
import { If } from '../if/if'
import Card from './card'
import Checkbox from './checkbox'
import Draggable from './draggable'

import {
  Container,
  Header,
  Head,
  Data,
  Wrapper,
  WrapperCard,
  NoContentText,
} from './styles'

type IProps = {
  data: ITable;
  isDraggable?: boolean;
}

const Table = ({ data, isDraggable = false }: IProps) => {
  const [actionItem, setActionItem] = useState<IHeaderItem | null>(null)
  const [items, setItems] = useState<IItem[]>([])
  const [titleStyle, setTitleStyle] = useState<any>({})

  useEffect(() => {
    (() => {
      const item = data.headerItems.find((i) => i.type === 'action') || null
      if (data.stylesOptions?.headerTitle) {
        setTitleStyle(data.stylesOptions?.headerTitle)
      }
      setActionItem(item)
      setItems([...data.items])
    })()
  }, [data])

  const handleOnDragEnd = (result: any) => {
    if (!result.destination) return
    const group = Array.from(items)
    const [reorderedItem] = group.splice(result.source.index, 1)
    group.splice(result.destination.index, 0, reorderedItem)
    setItems(group)
  }

  return (
    <Container>
      <Header>
        <If condition={data.hasCheckbox}>
          <Data size={0.3}><Checkbox /></Data>
        </If>
        {
          data.headerItems.map((head: any) => (
            <Head style={{ ...titleStyle }} key={head.label} size={head.size}>
              {head.label}
            </Head>
          ))
        }
      </Header>

      <DragDropContext onDragEnd={handleOnDragEnd}>
        <Droppable droppableId="data">
          {(provided) => (
            <Wrapper {...provided.droppableProps} ref={provided.innerRef}>
              {
                items.map((item: any, index: number) => (
                  <WrapperCard key={String(item.item.id)}>
                    <If condition={isDraggable}>
                      <Draggable
                        item={item}
                        data={data}
                        index={index}
                        actionItem={actionItem}
                      />
                    </If>
                    <If condition={!isDraggable}>
                      <Card
                        key={String(item.item.id)}
                        data={data}
                        group={item}
                        actionItem={actionItem}
                      />
                    </If>
                  </WrapperCard>
                ))
              }
              {provided.placeholder}

              <If condition={items.length <= 0}>
                <NoContentText>Nenhum item.</NoContentText>
              </If>
            </Wrapper>
          )}
        </Droppable>
      </DragDropContext>
    </Container>
  )
}

Table.defaultProps = {
  isDraggable: false,
}

export default Table
